import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import { columnsPayments } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { listPayments } from "../../Redux/Actions/paymentsActions";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListPayments = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [searchQuery, setSearchQuery] = useState("");
  // const [tempSearch, setTempSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };
      dispatch(listPayments(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh payment history list");
        }
      });
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails, debouncedSearch, dateRange]);

  const { payments } = useSelector((state) => state.payments || {});
  const loading = useSelector((state) => state.payments?.loading);

  useEffect(() => {
    if (payments?.total) {
      setPagination((prevData) => ({ ...prevData, total: payments.total }));
    }
  }, [payments]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponentsCp
        dataSource={Array.isArray(payments?.data) ? payments.data : []}
        pagination={pagination}
        onChange={handleTableChange}
        columns={columnsPayments}
        h3heading="Payments List"
        loading={loading}
        setState={setSearchQuery}
        onCalendarClick={() => setIsDatePopupVisible(true)}
      // filterFunction={filterHandler}
      ></TableComponentsCp>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListPayments;
